const logsDocs = `
### Research Logs Documentation

### Explanation
GoValuate logs capture high-level statistics from student coding sessions and track the full 
history of autograde results. These logs are designed to support empirical research in pedagogy, 
encourage academic honesty, and help identify potential integrity violations. When code logging is 
enabled, students are clearly notified through the user interface that instructors can view their 
progress throughout the evaluation. Each log session is bounded by autograder runs or on page exit. 
The summary statistics for a session capture all coding activity from the previous 
autograder run up to the next one or until page exit.

### Notice
Please note that any use of the GoValuate student-generated logs must comply with FERPA regulations.
If you plan to use the logs for research, you must anonymize them or request student consent.

### Reasons for data naming
In order to keep file sizes as small as possible, field names have been obfuscated as much as possible to limit byte storage.
The following API specifies exactly what each field represents and its value's type(s).

### Data API
s => [s]tartSession: str (str => ISO timestamp)\n
e => [e]ndSession\*: str (str => ISO timestamp)\n
f => [f]ocusChanges: int\n
c => [c]harsTyped: int\n
b => [b]ackspaces: int\n
p => [p]asteEvents: int\n
m => [m]ouseClicks: int\n
k => [k]eystrokes: int\n
x => cursorMoves: int\n
u => [u]uid: str (uuid of the Lambda question)\n
t => [t]ype: str (L => [L]ambda, P => [P]rogramming, S => [S]ession)\n
r => [r]esults: str | array (str => error, array => failed test identifier(s): str)\n

### Keystrokes Note
The keystrokes sum does not include tabs, newlines, backspaces, or any other key 
press that does not result in a single character addition at one time. Any command 
press that includes the control, meta, or alt keys will not be counted as a keystroke.

\*For the Lambda and the Programming log types, the \`e\` field represents when results from the GoValuate autograders were recorded and available to students.

`


export default logsDocs;